module.exports = __webpack_public_path__ + "img/postgresql.9474528e.svg";